import React from 'react';
import './App.css';
import { Router, Switch, Route, Redirect } from "react-router";
import { createBrowserHistory } from 'history';
import { SettingsPage } from './pages/Setting';
import { MainPage } from './pages/Main';
import { SecurePage } from './pages/Secure';

function App() {
  const history = createBrowserHistory();
  return (
    <div className="App">
            <Router history={history}>
                <Switch>
                    <Route path="/settings" component={() => <SettingsPage></SettingsPage>}/>
                    <Route path="/main" component={() => <MainPage></MainPage>} />
                    <Route path="/secure" component={() => <SecurePage></SecurePage>} />
                    <Redirect from="/" to="/main"/>
                </Switch>
            </Router>
    </div>
  );
}

export default App;
